export default "__VITE_ASSET__B8Wo$rwW__"